import { Navigate } from "react-router-dom";
import { useGetMeStatusQuery } from "../../store/services/PrivacyService";
import Loader from "../../components/main/Loader";
import React, { Children, cloneElement } from "react";

export function PrivacyGuard({children} : any) {

    const {data, isLoading}: any = useGetMeStatusQuery('');
    const documentiAziendali = data?.result?.documentiAziendaliDaVisionare;

    return <>
        {isLoading 
        ? <Loader />
        : documentiAziendali?.length > 0 
            // ? <Navigate to={"/privacy"} state={{ documentiAziendali }} />
            ? <Navigate to={"/privacy"} />
            : <>{children}</>
        }
    </>
 }

 export function PrivacyGuardOnPage({children} : any) {

    const {data, isLoading, isError}: any = useGetMeStatusQuery('');
    const documentiAziendali = data?.result?.documentiAziendaliDaVisionare;

    return <>
        {isLoading 
        ? <Loader />
        : isError 
          ? <Navigate to={"/"} />
          : documentiAziendali?.length > 0 
            ? <>
            {Children.map(children, (child) =>
              cloneElement(child, { documentiAziendali })
            )}
          </>
            : <Navigate to={"/dashboard/home"} state={{ documentiAziendali }} />
        }
    </>
 }
 